export function capitalize(str?: string) {
  return str ? str.charAt(0).toUpperCase() + str.slice(1) : str
}

export function formatInternalString(str: string, fallback: any = '') {
  if (!str) return fallback
  return capitalize(str.split('_').join(' '))
}
